export default __webpack_public_path__ + "static/rareshot-ddcd18336f854681e3d75f6d3601f489.png";